import * as React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@one-thd/sui-atomic-components";
import { OtpLoadingView } from "../../NewVerifyOtpModal/OtpModalViews";

const StencilModalWithLoader = ({isOpen, closeModal, headerText, modalBody, modalFooter, footerPosition="end", isLoading, loadingMessage}) => {

  return (
    <Modal
        open={isOpen}
        onClose={closeModal}
        size="sm"
    >
        <ModalHeader onClose={closeModal}>{headerText}</ModalHeader>
        { isLoading ? (
            <div className="otp-loading-container">
                <OtpLoadingView {...{loadingMessage}}/>
            </div>
        ) : (
            <>
                <ModalBody>
                    {modalBody}
                </ModalBody>
                <ModalFooter position={footerPosition}>
                    { modalFooter }
                </ModalFooter>
            </>
        )}
    </Modal>
  )
}

export default StencilModalWithLoader;